import {
  CountrySelectField,
  DateFormField,
  FormSection,
  GridContainer,
  GridItem,
  InputFormField,
} from "@duosoftbg/nacid-components";
import ARUniFreeSoloAutocompleteField from "../../../../../common/form/fields/ARUniFreeSoloAutocompleteField";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { countriesDataThunk } from "../../../../../../../store/redux/slice/AppData/countriesData";
import {
  getARUniDiplomaSpecialitiesAutocomplete,
  getARUniEduLevelsAutocomplete,
  getARUniUniversitiesAutocomplete,
} from "../../../../../../../axios/api/services";

const RequestUniDiplomaSection = () => {
  const countriesThunkState = useAppSelector((state) => {
    return state.AppData.countries;
  });

  return (
    <FormSection label={"t.arUniEntryRequest.diplomaUni.details"}>
      <GridContainer spacing={4} mt={0}>
        <GridItem sm={6} md={8}>
          <ARUniFreeSoloAutocompleteField
            required={true}
            labelCode={"l.arUniEntryRequest.university"}
            fieldName={"university"}
            autocompleteFn={getARUniUniversitiesAutocomplete}
          />
        </GridItem>
        <GridItem sm={6} md={4}>
          <CountrySelectField
            countryField={"universityCountry"}
            countryRequired={true}
            countriesThunk={countriesDataThunk}
            countriesThunkState={countriesThunkState}
            countryLabel={"l.arUniEntryRequest.universityCountry"}
            onlyActive={true}
          />
        </GridItem>
        <GridItem>
          <InputFormField
            required={false}
            labelCode={"l.arUniEntryRequest.diplomaNumber"}
            fieldName={"diplomaNumber"}
          />
        </GridItem>
        <GridItem>
          <DateFormField required={true} labelCode={"l.arUniEntryRequest.diplomaDate"} fieldName={"diplomaDate"} />
        </GridItem>
        <GridItem sm={6} md={8}>
          <ARUniFreeSoloAutocompleteField
            required={true}
            labelCode={"l.arUniEntryRequest.diplomaSpeciality"}
            fieldName={"diplomaSpeciality"}
            autocompleteFn={getARUniDiplomaSpecialitiesAutocomplete}
          />
        </GridItem>
        <GridItem sm={6} md={4}>
          <ARUniFreeSoloAutocompleteField
            required={true}
            labelCode={"l.arUniEntryRequest.educationLevel"}
            fieldName={"educationLevel"}
            autocompleteFn={getARUniEduLevelsAutocomplete}
          />
        </GridItem>
      </GridContainer>
    </FormSection>
  );
};
export default RequestUniDiplomaSection;
